export default __webpack_public_path__ + "static/media/logo138x75white.6e131b04.png";